<template>
    <vs-popup class="deposit-detail-popup" title="" :active.sync="depositDetailPopup.isOpen" :class="{'from-appointment': isFromAppointment}">
        <div class="md:flex" v-if="depositDetail">
            <div class="left-content">
                <div class="flex align-center my-4">
                    <p class="text-lg text-black customer-name" :style="`max-width: ${depositDetail.customer ? '' : 'unset'}`">{{ depositDetail.customer_name }}</p>
                    <vs-alert v-if="depositDetail.customer" :color="getMemberTypeColor(depositDetail.customer.type)" class="flex-center ml-3 type-alert">
                        {{ depositDetail.customer.type }}
                    </vs-alert>
                </div>
                <div class="mb-4">
                    <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1 font-bold" />
                    {{ StringHelper.phoneNumberFormat(depositDetail.customer_phone) }}
                </div>
                <div class="flex md:flex-col flex-row">
                    <div class="flex mb-6">
                        <div class="mr-base">
                            <p class="text-grey-custom mb-2">Points</p>
                            <p v-if="depositDetail.customer && depositDetail.customer.current_point != null">
                                {{ depositDetail.customer.current_point }}
                                <span v-if="depositDetail.customer.current_point > 1">Pts</span>
                                <span v-else>Pt</span>
                            </p>
                            <p v-else>N/A</p>
                        </div>
                        <div>
                            <p class="text-grey-custom mb-2">Visit</p>
                            <p v-if="depositDetail.customer && depositDetail.customer.visit_count != null">
                                {{ depositDetail.customer.visit_count }}
                                <span v-if="depositDetail.customer.visit_count > 1">times</span>
                                <span v-else>time</span>
                            </p>
                            <p v-else>N/A</p>
                        </div>
                    </div>
                    <div class="md:ml-0 ml-base">
                        <p class="text-grey-custom mb-2">Date Deposit</p>
                        <p class="mb-6">{{ formatDateTime(depositDetail.created_at) }}</p>
                        <!-- <p class="text-grey-custom mb-2">Date Settled</p>
                        <p class="mb-6">06/20/2020 03:35 PM</p> -->
                    </div>
                </div>
            </div>
            <div class="right-content">
                <vx-card class="text-black">
                    <div class="overflow-auto">
                        <div class="flex align-center mb-base">
                            <div class="w-full sm:flex align-center justify-between">
                                <div class="flex align-center left-col mr-4">
                                    <p class="font-bold">Deposit Details</p>
                                    <vs-alert :color="getStatusColor(depositDetail.status)" class="flex-center ml-3 type-alert">{{ getStatusName(depositDetail.status) }}</vs-alert>
                                </div>
                                <div class="flex align-center flex-grow-0 sm:mt-0 mt-6">
                                    <vs-button type="border" class="px-4 py-3" :class="{'mr-4': depositDetail.order_id != null}" v-if="depositDetail.appointment_id != null && !isFromAppointment" @click="openAppointmentDetail">View Appointment</vs-button>
                                    <vs-button class="px-4 py-3" v-if="depositDetail.order_id != null" @click="openOrderPopup">View Order</vs-button>
                                </div>
                            </div>
                        </div>

                        <div class="sm:flex align-start" v-if="depositDetail.service_detail">
                            <div class="flex align-center left-col sm:mb-0 mb-4">
                                <p class="font-bold">Payment Schedule</p>
                            </div>
                            <div>
                                <div class="flex-between mb-1" v-for="(item, index) in depositDetail.service_detail" :key="index">
                                    <div class="flex align-center">
                                        <p class="text-grey-custom grey-title">{{ item.name }}</p>
                                        <p class="ml-4">{{ item.staff_name }}</p>
                                    </div>
                                    <p class="font-bold ml-4">${{ formatNumber(item.price) }}</p>
                                </div>
                                <vs-divider></vs-divider>
                                <div class="flex-between mb-2" v-if="detailTotal && detailTotal.tax">
                                    <div class="flex align-center">
                                        <p class="text-grey-custom grey-title">Tax</p>
                                    </div>
                                    <p class="font-bold ml-4" v-if="detailTotal.tax">${{ detailTotal.tax / 100 }}</p>
                                </div>
                                <div class="flex-between" v-if="detailTotal">
                                    <div class="flex align-center">
                                        <p class="text-grey-custom grey-title">Total</p>
                                    </div>
                                    <!-- <p class="font-bold ml-4">${{ getServiceTotal(depositDetail.service_detail) }}</p> -->
                                    <p class="font-bold ml-4" v-if="detailTotal.total">${{ detailTotal.total / 100 }}</p>
                                    <p class="font-bold ml-4" v-else>$0</p>
                                </div>
                            </div>
                        </div>

                        <vs-divider v-if="depositDetail.service_detail"></vs-divider>

                        <div class="sm:flex align-start py-3" v-if="detailInfo">
                            <div class="flex align-center left-col sm:mb-0 mb-5">
                                <p class="font-bold">Deposit</p>
                            </div>
                            <div >
                                <div class="flex-between mb-3">
                                    <p class="font-bold">{{ formatDate(depositDetail.created_at) }} <span class="ml-2">{{ formatTime(depositDetail.created_at) }}</span></p>
                                    <p class="ml-4">
                                        <!-- <span class="text-grey-custom mr-4">(10%)</span> -->
                                        <span class="text-primary font-bold">${{ formatNumber(depositDetail.amount / 100) }}</span>
                                    </p>
                                </div>
                                <p class="flex align-center mb-3">
                                    <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary mr-1" />
                                    <span>Deposit Successful</span>
                                </p>
                                <!-- <div class="flex align-center mb-1">
                                    <p class="text-grey-custom grey-title">Tender:</p>
                                    <p class="ml-4">Credit Card</p>
                                </div> -->
                                <div class="flex align-center mb-1">
                                    <p class="text-grey-custom grey-title">Card Details:</p>
                                    <p class="ml-4" v-if="detailInfo">{{ detailInfo.source.brand }} {{ detailInfo.source.last4 }}</p>
                                    <p class="ml-4" v-else>N/A</p>
                                </div>
                                <div class="flex align-center">
                                    <p class="text-grey-custom grey-title">Transaction #:</p>
                                    <p class="ml-4" v-if="detailInfo">{{ detailInfo.id }}</p>
                                    <p class="ml-4" v-else>N/A</p>
                                </div>
                            </div>
                        </div>

                        <vs-divider v-if="depositDetail.refunds && depositDetail.refunds.length > 0"></vs-divider>

                        <div class="sm:flex align-start pt-3 sm:pb-0 pb-4" v-if="depositDetail.refunds && depositDetail.refunds.length > 0">
                            <div class="flex align-center left-col sm:mb-0 mb-5">
                                <p class="font-bold">Refund</p>
                            </div>
                            <div>
                                <div v-for="(item, index) in depositDetail.refunds" :key="index" :class="{'mt-6' : index != 0}">
                                    <div class="flex flex-between">
                                        <p class="font-bold">{{ formatDate(item.created_at) }} <span class="ml-2">{{ formatTime(item.created_at) }}</span></p>
                                        <p class="ml-4">
                                            <!-- <span class="text-grey-custom mr-3">(100%)</span> -->
                                            <span class="text-danger font-bold">-${{ formatNumber(item.amount / 100) }}</span>
                                        </p>
                                    </div>
                                    <p class="flex align-center">
                                        <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary mr-1" />
                                        <span>Refund Successful</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <vs-divider></vs-divider>

                        <div class="flex align-start">
                            <div class="flex align-center left-col">
                                <p class="font-bold">Balance</p>
                            </div>
                            <div class="text-right font-bold">${{ formatNumber(depositDetail.balance / 100) }}</div>
                        </div>
                    </div>
                </vx-card>
                <vx-card class="text-black mt-4" v-if="isShowChargePage">
                  <div class="flex items-start">
                    <vs-input
                      placeholder="$ 0.00"
                      v-model="amount"
                      :danger="!!amountError"
                      :danger-text="amountError"
                      class="w-3/5 mr-4"
                    />
                    <vs-button
                      color="primary"
                      type="filled"
                      @click="handleCharge"
                      class="w-2/5 flex-shrink-0"
                      :disabled="isChargeLoading"
                    >
                      Charge
                    </vs-button>
                  </div>
                </vx-card>
            </div>
        </div>
    </vs-popup>
</template>


<script>
import moment from "moment";
import { changeFormatWithDateTime, changeFormatHelper } from '../../helper/datetimeHelper';
import { StringHelper } from "../../models/string_helper";
export default {
    name: "deposit-detail-popup",
    props: {
        depositDetailPopup: {
            type: Object,
            required: true
        },
        isFromAppointment: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            StringHelper,
            amount: null,
            isAmountError: false,
            amountError: null,
            isChargeLoading: false,
        }
    },
    methods: {
        getMemberTypeColor(member_type) {
            if (member_type == "new") return "success";
            if (member_type == "atrisk") return "warning";
            if (member_type == "vip") return "danger";
            if (member_type == "regular") return "primary";
            if (member_type == "booking") return "booking";
            if (member_type == "import") return "import";
            return "purple";
        },
        getStatusColor(status) {
            if(status == "Success") return "success";
            if(status == "Failed") return "danger";
            return "purple";
        },
        getStatusName(status) {
            if(status == "Success") return "Success";
            if(status == "Failed") return "Failed";
            return status;
        },
        formatDateTime(date) {
            if(date) return changeFormatWithDateTime(date);
            return "N/A";
        },
        formatDate(date) {
            if(date) return changeFormatHelper(date);
            return "N/A";
        },
        formatTime(date) {
            if(date) return moment(date).format("hh:mm A");
            return "";
        },
        formatNumber(value) {
            // if(value) return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            if(value) return +(Math.round(value + "e+2") + "e-2");
            return 0;
        },
        // getServiceTotal(service_detail) {
        //     let result = 0;
        //     if(service_detail && service_detail.length > 0) {
        //         for(let i = 0; i < service_detail.length; i++) {
        //             result += parseFloat(service_detail[i].price);
        //         }
        //     }
        //     return this.formatNumber(result);
        // },
        openAppointmentDetail() {
            this.$emit("OpenAppointmentDetail", this.depositDetail.appointment_id);
        },
        openOrderPopup() {
            this.$emit("OpenOrderPopup", this.depositDetail.order_id);
        },
        async reload() {
          try {
            this.$store.dispatch("appointment/GET_DEPOSIT_DETAIL", {
              id:  this.depositDetail.id,
            })
          } catch (error) {
            console.error(error);
          }
        },
        async handleCharge() {
          try {
            const isNumeric = str => /^[1-9]\d*$/.test(str);

            this.amountError = null;
            if(!this.amount || !isNumeric(this.amount)) {
              return this.amountError = 'Please enter valid amount';
            }
            this.isChargeLoading = true;
            await this.$store.dispatch("appointment/CHARGE_DEPOSIT", {
              amount: this.amount * 100,
              appointment_id: this.depositDetail.appointment_id,
              external_deposit_id: this.depositDetail.external_deposit_id,
            });
            await this.reload();
            this.$vs.notify({title:'Charge success', color: 'success'});

            this.$emit("changeSuccess");
          } catch (error) {
            this.$vs.notify({title:'Charge failed', text: error.message, color: 'danger', time: 5000});
          } finally {
            this.isChargeLoading = false;
          }
        },
    },
    computed: {
        depositDetail() {
            // console.log("Detail: ", this.$store.getters["appointment/depositDetail"]);
            return this.$store.getters["appointment/depositDetail"];
        },
        detailInfo() {
            if(this.depositDetail && this.depositDetail.detail_info && JSON.parse(this.depositDetail.detail_info)) {
                return JSON.parse(this.depositDetail.detail_info);
            }
            return null;
        },
        detailTotal() {
            if(this.depositDetail && this.depositDetail.data && JSON.parse(this.depositDetail.data)) {
                let data = JSON.parse(this.depositDetail.data);
                if(data.fastboy_service_payload && data.fastboy_service_payload.appointment && data.fastboy_service_payload.appointment.total) {
                    return data.fastboy_service_payload.appointment.total;
                }
            }
            return null;
        },
        isShowChargePage() {
          return this.depositDetail && !this.depositDetail.amount
        }
    },
}
</script>
